import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronUpIcon } from '@heroicons/react/24/outline';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 280) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) return null;

  // Check if current page has a sticky mobile CTA bottom bar (Product Detail, Digital Bundle Detail)
  const hasBottomBar = 
    location.pathname.startsWith('/product/') || 
    location.pathname.startsWith('/digital-bundle/') ||
    location.pathname.startsWith('/course/');

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      title="Scroll to top"
      className={`fixed right-4 sm:right-6 z-40 bg-white hover:bg-primary text-black border-2 sm:border-3 border-black p-2.5 sm:p-3 shadow-[3px_3px_0px_0px_#000000] sm:shadow-[4px_4px_0px_0px_#000000] hover:shadow-[5px_5px_0px_0px_#000000] hover:-translate-y-1 active:translate-y-0.5 active:shadow-none transition-all duration-300 flex items-center justify-center group cursor-pointer ${
        hasBottomBar
          ? 'bottom-[180px] sm:bottom-[192px] lg:bottom-26'
          : 'bottom-24 sm:bottom-28'
      }`}
    >
      <ChevronUpIcon className="h-5 w-5 sm:h-6 sm:w-6 stroke-[3] group-hover:-translate-y-0.5 transition-transform" />
      <span className="hidden sm:inline-block ml-1 text-xs font-black uppercase tracking-wider">Top</span>
    </button>
  );
};

export default ScrollToTopButton;
